/**
 * Einfacher Mutex für serialisierten Zugriff auf Ressourcen.
 * Verwendung:
 * ```
 * const mutex = new Mutex();
 * const unlock = await mutex.lock();
 * try {
 *   // kritischer Abschnitt
 * } finally {
 *   unlock();
 * }
 * ```
 */
export class Mutex {
	private mutex = Promise.resolve();

	lock(): PromiseLike<() => void> {
		let begin: (unlock: () => void) => void = (_) => {};

		this.mutex = this.mutex.then(() => {
			return new Promise(begin);
		});

		return new Promise(res => {
			begin = res;
		});
	}
}
